import {
  encodeQueryParams,
  JsonParam,
  StringParam,
  ArrayParam,
} from 'use-query-params'
import qs from 'query-string'

export function getRedirectionLink(stage: string, history: any) {
  const queryParams = encodeQueryParams(
    {
      stage: ArrayParam,
      sort: JsonParam,
      item_types: StringParam,
    },
    {
      stage: [stage],
      sort: {
        sort_by: 'client_deadline',
        sort_order: 'desc',
      },
      item_types: 'assignment',
    }
  )

  return history.push(`projects/items?${qs.stringify(queryParams)}`)
}
